/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { environment } from './environments/environment';
import { AppModule } from './app/features/app.module';

//inicializar Sentry
if (environment.sentry?.dsn) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      // Sentry.consoleLoggingIntegration({ levels: ["warn", "error"] }),
    ],
    ignoreErrors: [
      /ExpressionChangedAfterItHasBeenCheckedError/,
      /NG0100/
    ],
    environment: environment.sentry.environment,
    tracesSampleRate: environment.sentry.tracesSampleRate,
    sampleRate: environment.sentry.sampleRate,
    // enableLogs: true,
    tracePropagationTargets: [
      'localhost',
      environment.host,
      /^\//,
    ],
    //filtra datos sensibles antes de enviar a Sentry
    beforeSend(event, hint) {
      if (event.request?.headers) {
        delete event.request.headers['Authorization'];
        delete event.request.headers['Cookie'];
      }
      if (event.user?.email) {
        event.user.email = event.user.email.replace(/(.{2}).*@/, '$1***@');
      }
      return event;
    },
  });
}

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(AppModule)
  .catch(err => console.log(err));

// export { renderModule, renderModuleFactory } from '@angular/platform-server';